import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    @Input() title: string;
    @Input() classes: string;
    @Input() game: string;

    backgrounds = {
      'lol':'background1',
      'tft':'background1',
      'wild-rift':'background1',
      'valorant':'background2',
      'apex':'background3',
      'cs2':'background4',
      'marvel':'background5'
    }
}
